import { Injectable, inject, signal } from '@angular/core';
import { LocalStorageService } from '@services/localStorage/local-storage-service.service';
import { InfrastructureCatalogItem, NetworkCatalogItem } from './models/infrastructure-catalog.model';

export const INFRASTRUCTURE_STORAGE_KEY = 'strId';

@Injectable({ providedIn: 'root' })
export class InfrastructureSelectionService {
  private readonly ls = inject(LocalStorageService);

  private readonly _selectedStrId = signal<string | null>(
    this.ls.getItem<string | null>(INFRASTRUCTURE_STORAGE_KEY, null)
  );
  readonly selectedStrId = this._selectedStrId.asReadonly();

  select(strId: string): void {
    this._selectedStrId.set(strId);
    this.ls.setItem(INFRASTRUCTURE_STORAGE_KEY, strId);
  }

  selectDefaultIfMissing(infrastructures: InfrastructureCatalogItem[], networks: NetworkCatalogItem[] = []): void {
    if (this._selectedStrId()) return;
    const first =
      infrastructures.find(i => !i.isPetitioned) ??
      networks.flatMap(n => n.Infrastructures).find(i => !i.isPetitioned);
    if (first) this.select(first.str_id);
  }
}
